/** A4 portrait width at 96 dpi (210 mm × 96 / 25.4). */
export const A4_WIDTH_PX = 793;

/** A4 portrait height at 96 dpi (297 mm × 96 / 25.4). */
export const A4_HEIGHT_PX = 1123;

/** Below this measured container width, table renderers enter compact mode. */
export const COMPACT_VIEWPORT_PX = 700;
